<template>
    <el-dialog
        class="tax-and-gen2-dialog"
        append-to-body
        :visible="visible"
        :close-on-click-modal="false"
        @close="onClose"
    >
        <div class="dialog-inner">
            <div class="dialog-title">各類代扣稅率簡表</div>
            <table class="line-table" cellpadding="0" cellspacing="0">
                <thead>
                    <tr>
                        <th>所得類別</th>
                        <th class="taxTh">
                            <div style="margin-bottom: 5px;">勞務稅</div>
                            <el-radio-group v-model="residentType" size="mini" class="resident-tab">
                                <el-radio-button label="居住者"></el-radio-button>
                                <el-radio-button label="非居住者"></el-radio-button>
                            </el-radio-group>
                            <div class="th-note">
                                <div v-if="residentType === '居住者'">(在台居住滿 183 天)</div>
                                <div v-if="residentType === '非居住者'">(在台居住未滿 183 天)</div>
                            </div>
                        </th>
                        <th class="gen2Th">二代健保補充保費</th>
                    </tr>
                </thead>
                <tbody v-if="serviceTypeList">
                    <tr v-for="item in serviceTypeList" :key="item.value">
                        <td class="typeTd">{{ item.label }}</td>
                        <td class="taxTd" v-if="residentType === '居住者'">{{ item.notes.residentTax }}</td>
                        <td class="taxTd" v-if="residentType === '非居住者'">{{ item.notes.nonresidentTax }}</td>
                        <td class="gen2Td" style="white-space: nowrap;">{{ item.notes.gen2 }}</td>
                    </tr>
                </tbody>
            </table>
            <ul class="note-list">
                <li>基本工資：{{ MINIMUM_WAGE }} 元 (2026年1月1日實施)</li>
                <li>二代健保補充保費代扣金額以四捨五入計算至整數。</li>
                <li>勞務稅代扣金額以無條件捨去計算至整數。</li>
                <li>如果有職業工會加保，不代扣二代健保補充保費。</li>
                <li>參考資料：<a href="https://www.ntbca.gov.tw/singlehtml/a15c33c827e4470c9263930ab2087812?cntId=11d7f1c11adb4c57b434aca3c95cbf93#gsc.tab=0" target="_blank">各類所得扣繳率簡表</a></li>
                <li>參考資料：<a href="https://www.nhi.gov.tw/ch/cp-2481-95b64-3153-1.html" target="_blank">全民健康保險扣取及繳納補充保險費實務手冊</a></li>
            </ul>
            <div style="text-align: right;">
                <el-button @click="onClose" icon="el-icon-close">關閉</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { serviceTypeList, TAX_AMT_THRESHOLD, MINIMUM_WAGE } from '@/assets/commonData/options';

export default {
    name: 'TaxAndGen2Dialog',
    props: {
        visible: {
            Type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            residentType: '居住者',
            serviceTypeList,
            TAX_AMT_THRESHOLD,
            MINIMUM_WAGE,
        };
    },
    methods: {
        onClose() {
            this.$emit('close', null);
        },
    },
};
</script>
<style lang="scss">
.tax-and-gen2-dialog {

    .el-dialog {
        width: 95%;

        @media (min-width: 1024px) {
            width: 900px;
        }
    }

    .dialog-inner {
        width: 100%;
        padding: 0 15px;
    }

    .dialog-title {
        text-align: center;
        font-size: 13pt;
        font-weight: bold;
        margin: 0 0 20px 0;
        color: #000;
    }

    .line-table {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
        border-left: 1px solid #000;
        border-top: 1px solid #000;
        width: 100%;
        font-size: 10.5pt;
        color: #000;

        td, th {
            border-top: 1px solid #000;
            border-left: 1px solid #000;
            padding: 10px 10px;
        }
    }

    .th-note {
        font-size: 9pt;
        font-weight: normal;
    }

    .note-list {
        font-size: 9pt;
        padding: 10px 0;
        margin: 10px 0 0 20px;
    }

    .resident-tab.el-radio-group {
        .el-radio-button {
            &.is-active {
                opacity: 1;
            }
        }
    }
    .typeTd {
        @media (min-width: 720px) {
            white-space: nowrap;
        }
    }
    .taxTh {
        background-color: #b4d8f9;
    }
    .taxTd {
        background-color: #e2effa;
        max-width: 200px;
    }
    .gen2Th {
        background-color: #b3f6b6;
    }
    .gen2Td {
        background-color: #e5fce6;
    }

}
</style>
